import {b64tohex, KJUR} from 'jsrsasign' // base64转16进制 验签所需插件
import CryptoJS from 'crypto-js' // AES
import forge from 'node-forge' // RSA
import {
	del,
	get,
	post,
	put,
	toExcel,
	upload
} from './axios'
import store from '../store/index.js'


 
// 生成AES密钥
function getmm(num = 16) {
  var amm = ['!', '@', '#', '$', '%', '&', '*', '(', ')', '_', 1, 2, 3, 4, 5, 6, 7, 8, 9]
  var tmp = Math.floor(Math.random() * num)
  var s = tmp
  s = s + amm[tmp]
  for (let i = 0; i < Math.floor(num / 2) - 1; i++) {
    tmp = Math.floor(Math.random() * 26)
    s = s + String.fromCharCode(65 + tmp)
  }
  for (let i = 0; i < (num - Math.floor(num / 2) - 1); i++) {
    tmp = Math.floor(Math.random() * 26)
    s = s + String.fromCharCode(97 + tmp)
  }
  return s
}

// 生成客户端RSA公钥和私钥 需要双向加密时需要，将在文末讨论
// export function jsrsasignFn() {
//   var rsaKeypair = jsrsasign.KEYUTIL.generateKeypair('RSA', 2048)
//   var private1 = jsrsasign.KEYUTIL.getPEM(rsaKeypair.prvKeyObj, 'PKCS1PRV')
//   var public1 = jsrsasign.KEYUTIL.getPEM(rsaKeypair.pubKeyObj)
//   let a = {
//     'privateKey': private1.substring(31, private1.length - 31).replace(/\r\n/g, ''),
//     'publicKey': public1.substring(28, public1.length - 28).replace(/\r\n/g, '')
//   }
//   console.log(a)
//   return a
// }

// AES 加密  data：要加密解密的数据，AES_KEY：密钥，
function encrypt(data, AES_KEY) {
  const key = CryptoJS.enc.Utf8.parse(AES_KEY)
  const encrypted = CryptoJS.AES.encrypt(data, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  // console.log("加密数据：" + data)
  // console.log("数据加密后：" + encrypted.toString())
  return encrypted.toString()
}

// 使用服务端的公钥加密AES密钥
function pubencrypt(aeskey, pubencryptKey) {
	
  // console.log("aeskey：" + aeskey)
  // console.log("服务器公钥：" + pubencryptKey)
  // 此处的前后缀不能改变
  const publicKeyAll = '-----BEGIN PUBLIC KEY-----\n' + pubencryptKey + '\n-----END PUBLIC KEY-----'
  var publicKey = forge.pki.publicKeyFromPem(publicKeyAll)
  var buffer = forge.util.createBuffer(aeskey, 'utf8')
  var bytes = buffer.getBytes()
  // console.log("公钥加密后的AES密钥：" + bytes)
  return forge.util.encode64(publicKey.encrypt(bytes, 'RSAES-PKCS1-V1_5'))
}

// post请求参数加密
export function resEncryption(data) {
	
		
			
				// 生成随机密钥（key）
				var key = getmm()
				// 密钥 加密 数据（将json转成字符串再进行加密）
				var newData = encrypt(JSON.stringify(data), key)
				// console.log("--------------------"+newData)
				// 公钥 加密 密钥（key组成）
				var aesKey = pubencrypt(key, store.state.key)
				// console.log(aesKey)
				// 返回数据
				let formData = new FormData();
				formData.append('data', newData)
				formData.append('aesKey', aesKey)
				// console.log(formData);
				 return formData
			
	
			
		
 
 
}

// get请求参数加密
export function resEncryptionForGet(data) {
  // 生成随机密钥（key）
  var key = getmm()
  // 密钥 加密 数据（将json转成字符串再进行加密）
  var newData = encrypt(JSON.stringify(data), key)
  console.log("--------------------"+newData)
  // 公钥 加密 密钥（key组成）
  var aesKey = pubencrypt(key, store.state.key)
  // console.log(aesKey)
  // 返回数据
  return {
    'data': newData,
    'aesKey': aesKey
  }
}

// 使用服务端的公钥验签AES密钥
function pubverify(aeskey, pubencryptKey, sign) {
	
  // console.log("aeskey：" + aeskey)
  // console.log("服务器公钥：" + pubencryptKey)
  const publicKeyAll = '-----BEGIN PUBLIC KEY-----\n' + pubencryptKey + '\n-----END PUBLIC KEY-----'
  try {
    let sig =  new KJUR.crypto.Signature({alg: "MD5withRSA"});
    sig.init(publicKeyAll)
    sig.updateString(aeskey)
    return sig.verify(b64tohex(sign))
  } catch (e) {
    // console.log(e)
  }
}

// AES 加密  data：要加密解密的数据，AES_KEY：密钥，
function aesDecrypt(data, AES_KEY) {
  // console.log("---------------------开始解密AES")
  const decrypted = CryptoJS.AES.decrypt(data.toString(), CryptoJS.enc.Utf8.parse(AES_KEY), {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  // console.log("数据：" + data.toString())
  // console.log("解密后：" + decrypted.toString(CryptoJS.enc.Utf8))
  return decrypted.toString(CryptoJS.enc.Utf8)
}

// 响应解密
export function resDecryption(data) {
  // 使用公钥先验签aesKey
  let verifyResult = pubverify(data.aesKey, store.state.key, data.sign);
 
  if (!verifyResult) {
	  // console.log(123);
    this.$message({
      type: 'warning',
      message: '响应数据不合法！'
    });
    return ;
  }
  // console.log(verifyResult)
  // 使用aesKey解密数据
  return aesDecrypt(data.data, data.aesKey);
}